import React from 'react';
import { useTheme } from '../../../../themes';

const InvoiceIcon = ({ className }: { className?: string }) => {
  const theme = useTheme();

  return (
    <svg
      className={className}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" stroke="black">
        <path d="M53.125 27.1458L62.7917 33.7917V59.1667C62.7917 61.1687 61.1687 62.7917 59.1667 62.7917H10.8333C8.8313 62.7917 7.20833 61.1687 7.20833 59.1667V33.7917L16.875 27.1458" />
        <path d="M14.4679 55.5417L26.5512 45.875H43.4679L55.5512 55.5417" />
        <path d="M62.8012 33.7917L48.3012 43.4583" />
        <path d="M7.21786 33.7917L21.7179 43.4583" />
        <path d="M53.125 40.2345V9.625C53.125 8.29031 52.043 7.20833 50.7083 7.20833H19.2917C17.957 7.20833 16.875 8.29031 16.875 9.625V40.2345" />
        <path d="M22.9262 16.875H33.8012" />
        <path d="M22.9262 21.7083H33.8012" />
        <path d="M22.9262 26.5417H28.9679" />
        <g stroke={theme.colors.dashboardAccent}>
          <path d="M43.4679 26.5417V28.9583" />
          <path d="M43.4679 14.4583V16.875" />
          <path d="M38.625 26.5417H45.875C47.2097 26.5417 48.2917 25.4597 48.2917 24.125C48.2917 22.7903 47.2097 21.7083 45.875 21.7083H41.0417C39.707 21.7083 38.625 20.6264 38.625 19.2917C38.625 17.957 39.707 16.875 41.0417 16.875H48.2917" />
        </g>
      </g>
    </svg>
  );
};

export default InvoiceIcon;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/subpages/RefundGuidePage/InvoiceIcon.tsx